(() => {
  function focusSearch() {
    // Pick the first visible search input
    const candidates = Array.from(document.querySelectorAll(
      'predictive-search input[type="search"], .search-modal input[type="search"], header input[type="search"], form[action*="/search"] input[type="search"], input[name="q"][type="search"]'
    )).filter(el => {
      const s = window.getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && el.offsetParent !== null;
    });

    const input = candidates[0];
    if (input) {
      requestAnimationFrame(() => {
        input.focus({ preventScroll: true });
        if (input.select) input.select();
      });
    }
  }

  // Focus after clicking typical search triggers (covers Dawn & Prestige)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-action*="search"], .header__icon--search, button[aria-controls*="Search"], a[href="#search"], .js-open-search');
    if (trigger) setTimeout(focusSearch, 60);
  });

  // For themes that open search via <details> or <dialog>
  const observeDetails = () => {
    document.querySelectorAll('details').forEach(d => {
      d.addEventListener('toggle', () => {
        if (d.open && /search/i.test(d.className + ' ' + d.id)) setTimeout(focusSearch, 60);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', observeDetails);
  document.addEventListener('shopify:section:load', () => {
    observeDetails();
    setTimeout(focusSearch, 60);
  });
})();
